import { useQuery } from '@tanstack/react-query';

import type { ConfigResponse } from '@/lib/api';
import { configApi } from '@/lib/api';
import { deriveSessionTimingConfig, type SessionTimingConfig } from '@/lib/derive-session-timing';
import { useSessionStore } from '@/stores/session';

import { queryKeys } from './query-keys';

export interface ConfigQueryData {
  policy: ConfigResponse;
  timing: SessionTimingConfig | null;
}

export function useConfigQuery() {
  const sessionStatus = useSessionStore((s) => s.status);
  return useQuery({
    queryKey: queryKeys.config.root,
    queryFn: () => configApi.getConfig(),
    enabled: sessionStatus !== 'initializing',
    select: (policy): ConfigQueryData => ({
      policy,
      timing: policy.session ? deriveSessionTimingConfig(policy.session) : null,
    }),
  });
}
